import { render, staticRenderFns } from "./other-scripts.vue?vue&type=template&id=0a08ea3b&"
import script from "./other-scripts.vue?vue&type=script&lang=js&"
export * from "./other-scripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports